
import NoteRemove from "../../../assets/filled/NoteRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function NoteRemoveIcon({ className, dataTestid = "NoteRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <NoteRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
